module.exports = __webpack_public_path__ + "img/ee.aafa1c5a.svg";